import React, { useEffect } from "react";
import styles from "./NFCIntro.module.scss";
import { MouseParallax, ScrollParallax } from "react-just-parallax";
import { animate, stagger } from "animejs";

const NFCIntro = () => {
  const handleAnimate = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    animate(".emoji", {
      translateY: "-3000",
      "background-color": "#7c2c3f",
      filter: "blur(5px)",
      delay: stagger(100),
      ease: "inQuad",
    });

    animate(".wrapp", {
      translateY: "-3000",
      background: "#A6904B",
      filter: "blur(5px)",
      delay: 400,
      ease: "inQuad",
    });

    animate(".titleH1", {
      translateX: { from: "-50%", to: "-50%" },
      translateY: { from: "-50%", to: "-350%" },
      delay: 150,
      ease: "inQuad",
    });
  };

  useEffect(() => {
    setTimeout(() => {
      handleAnimate();
    }, 6000);
  }, []);

  const emojis = [
    { symbol: "🌈", top: "70%", left: "15%", index: 1 },
    { symbol: "⭐️", top: "53%", left: "31%", index: 2 },
    { symbol: "🪰", top: "64%", left: "70%", index: 3 },
    { symbol: "🍌", top: "30%", left: "70%", index: 4 },
    { symbol: "🩷", top: "20%", left: "23%", index: 5 },
    { symbol: "🙈", top: "12%", left: "57%", index: 6 },
  ];

  return (
    <>
      <div
        className={`${styles.IntroWapper} wrapp`}
        style={{ backgroundColor: "black" }}
      >
        <h1 className={`${styles.title} titleH1`}>Hola</h1>
        {emojis.map((emoji, index) => (
          <div className={styles.emojis} key={index}>
            <ScrollParallax strength={0.5} lerpEase={0.5}>
              <MouseParallax strength={0.1} lerpEase={0.1} enableOnTouchDevice>
                <div
                  className={`${styles.emoji} emoji`}
                  style={{
                    position: "absolute",
                    top: emoji.top,
                    left: emoji.left,
                    fontSize: "3rem",
                  }}
                >
                  {emoji.symbol}
                </div>
              </MouseParallax>
            </ScrollParallax>
          </div>
        ))}
      </div>
    </>
  );
};

export default NFCIntro;
